module.exports = __webpack_public_path__ + "static/media/120-basque-country.96337f35.svg";